import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { TWILIO_INTEGRATION_PATH } from '../api'
import { TwilioIntegrationInterface, TwilioIntegrationPostInterface } from '../types'

export function useTwilioActions() {
  const { fetcher: postFetcher } = useFetch<
    RequestMethodsEnum.post,
    TwilioIntegrationInterface,
    TwilioIntegrationPostInterface
  >({
    method: RequestMethodsEnum.post,
  })

  const { fetcher: deleteFetcher } = useFetch<RequestMethodsEnum.delete>({
    method: RequestMethodsEnum.delete,
  })

  return {
    postIntegration: (data: TwilioIntegrationPostInterface) =>
      postFetcher(TWILIO_INTEGRATION_PATH, data),
    deleteIntegration: () => deleteFetcher(TWILIO_INTEGRATION_PATH),
  }
}
